import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { afterPageLoad } from '../utils/afterPageLoad';

const SCRIPT_ID = 'gio-contentsquare-uxa';
const SCRIPT_SRC = 'https://t.contentsquare.net/uxa/ef2211a694c06.js';

/** Prefixos de pathname onde Contentsquare/Hotjar UXA deve carregar (LPs + funil de conversão). */
const CONVERSION_PATH_PREFIXES = [
  '/lp',
  '/register',
  '/lead',
  '/creating-account',
  '/select-plan',
];

function isConversionPath(pathname) {
  if (!pathname || typeof pathname !== 'string') return false;
  const path = pathname.toLowerCase();
  return CONVERSION_PATH_PREFIXES.some(
    (prefix) => path === prefix || path.startsWith(`${prefix}/`) || path.startsWith(`${prefix}-`)
  );
}

/** Etapas em tela cheia do onboarding. O restante do projeto não carrega o Hotjar. */
export const ONBOARDING_CONTENTSQUARE_STEPS = ['site', 'connect', 'learning', 'review'];

export function shouldLoadContentsquare({ pathname, onboardingStep } = {}) {
  if (isConversionPath(pathname)) return true;
  return ONBOARDING_CONTENTSQUARE_STEPS.includes(onboardingStep);
}

export function loadContentsquare() {
  if (typeof window === 'undefined' || typeof document === 'undefined') return;
  if (window.__gioContentsquareLoaded) return;
  if (document.getElementById(SCRIPT_ID)) {
    window.__gioContentsquareLoaded = true;
    return;
  }

  const script = document.createElement('script');
  script.id = SCRIPT_ID;
  script.async = true;
  script.src = SCRIPT_SRC;
  document.head.appendChild(script);
  window.__gioContentsquareLoaded = true;
}

/**
 * Injeta a tag Contentsquare UXA nas LPs e, no app, só nas etapas de onboarding.
 * Não remove o script ao sair (a gravação da sessão pode continuar).
 * Não carrega no projeto quando o onboarding já terminou.
 */
export function useContentsquare() {
  const location = useLocation();

  useEffect(() => {
    if (!isConversionPath(location.pathname)) return;
    // Nas LPs o script espera o load: não compete com o LCP.
    afterPageLoad(loadContentsquare);
  }, [location.pathname]);
}

export { CONVERSION_PATH_PREFIXES, isConversionPath };
